module.exports = __webpack_public_path__ + "img/logo.34c63c44.svg";